import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/services/api.service';
import { of } from 'rxjs';

const baseUrl = `/relatorio`;
const baseUrlRelatorioCapitulo = `/relatorio-capitulo`;

const routes = {
  consultBingoSemCapitulo: `${baseUrl}/bingo`,
  consultBingoSemCapituloAll: `${baseUrl}/bingo/all`,
  consultBingo: (idCapitulo: number) => `${baseUrl}/bingo/capitulo/${idCapitulo}`,
  consultRelatorioRoteiro: `${baseUrl}/roteiro`,
  typeRelatorioRoteiro: `${baseUrl}/roteiro/tipos-relatorio`,
  consultRelatorioPersonagemRoupa: `${baseUrl}/personagem-roupa`,
  consultRelatorioCapituloContinuidade: `${baseUrl}/capitulo-continuidade`,
  consultRelatorioFiguranteRoupa: `${baseUrl}/figurante-roupa`,
  consultRelatorioRoupaPedido: `${baseUrl}/pedido-roupa`,
  consultRelatorioRoteiroDecupagem: `${baseUrl}/decupagem-artistica`,
  consultRelatorioEstatisticasGravacao: `${baseUrl}/estatisticas-gravacao`,
  consultRelatorioCapitulosFinalizados: `${baseUrl}/capitulo-finalizado`,
  consultRelatorioOcorrencia: `${baseUrl}/ocorrencias`,
  consultRoteiroContinuidade: `${baseUrl}/roteiro-continuidade`,
  tipoRelatorioCapitulo: `${baseUrlRelatorioCapitulo}/tipos-relatorio`,
  consultRelatorioCapitulo: `${baseUrlRelatorioCapitulo}`,

  typeRelatorioCapitulo: `${baseUrl}/capitulo/tipos-relatorio`,
  consultRelatorioContinuidade: `${baseUrl}/roteiro/continuidade`,
  consultRelatorioControleGravacao: `${baseUrl}/controle-de-gravacao`,
  consultRelatorioGravacao: `${baseUrl}/gravacao`,
  consultRelatorioRoteiroArte: `${baseUrl}/roteiro/arte`,
  tipos: `${baseUrl}/roteiro/tipos`,
  tiposPersonagemRoupa: `${baseUrl}/personagem-roupa/tipos`,
  tiposBooleano: `${baseUrl}/personagem-roupa/tiposbool`,
  tiposBooleanoRelatorioRoupaPedido: `${baseUrl}/pedido-roupa/tiposbool`,

  downloadPdfBingoAll: `${baseUrl}/bingo/exportarTudo`,
  downloadPdfBingo: (idCapitulo: number) => `${baseUrl}/bingo/exportar/${idCapitulo}`,
}
@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  [key: string]: any;

  constructor(private apiService: ApiService) { }

  consultarRelatorioBingoSemCapitulo() {
    return this.apiService.get<any>(routes.consultBingoSemCapitulo);
  }

  consultarRelatorioBingoSemCapituloAll() {
    return this.apiService.get<any>(routes.consultBingoSemCapituloAll);
  }

  consultarRelatorioBingo(idCapitulo: any) {
    return this.apiService.get<any>(routes.consultBingo(idCapitulo));
  }

  consultarRelatorioRoteiro(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioRoteiro, obj);
  }

  tiposRelatorioRoteiro() {
    return this.apiService.get<any>(routes.typeRelatorioRoteiro);
  }

  consultarRelatorioCapitulo(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioCapitulo, obj);
  }

  consultarRelatorioContinuidade(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioContinuidade, obj);
  }

  consultarRelatorioFiguranteRoupa(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioFiguranteRoupa, obj);
  }

  consultarRelatorioPersonagemRoupa(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioPersonagemRoupa, obj);
  }

  consultarRelatorioRoupaPedido(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioRoupaPedido, obj);
  }

  consultarRelatorioCapituloContinuidade(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioCapituloContinuidade, obj);
  }

  consultarRelatorioControleGravacao(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioControleGravacao, obj);
  }

  consultarRelatorioRoteiroDecupagem(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioRoteiroDecupagem, obj);
  }

  consultarRelatorioGravacao(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioGravacao, obj);
  }

  consultarRelatorioRoteiroArte(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioRoteiroArte, obj);
  }

  consultarRelatorioCapitulosFinalizados(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioCapitulosFinalizados, obj);
  }

  consultarRelatorioEstatisticasGravacao() {
    return this.apiService.downloadGetBlobWithFilename(routes.consultRelatorioEstatisticasGravacao);
  }

  consultarRelatorioOcorrencia(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRelatorioOcorrencia, obj);
  }

  consultarRelatorioRoteiroContinuidade(obj: any) {
    return this.apiService.downloadPostBlobWithFilename(routes.consultRoteiroContinuidade, obj);
  }

  tiposRelatorio() {
    return this.apiService.get(routes.tipos);
  }

  tiposRelatorioPersonagemRoupa() {
    return this.apiService.get(routes.tiposPersonagemRoupa);
  }

  tiposBooleanoRelatorioPersonagemRoupa() {
    return this.apiService.get(routes.tiposBooleano);
  }

  tiposBooleanoRelatorioRoupaPedido() {
    return this.apiService.get(routes.tiposBooleanoRelatorioRoupaPedido);
  }

  downloadPdfBingoAll() {
    return this.apiService.downloadGet(routes.downloadPdfBingoAll);
  }

  downloadPdfBingo(idCapitulo: any) {
    return this.apiService.downloadGet(routes.downloadPdfBingo(idCapitulo));
  }

  listartiposRelatorioCapitulo() {
    return this.apiService.get<any>(routes.tipoRelatorioCapitulo);
  }

  ordenacaoRelatorioRoteiro() {
    return of([
      { id: 1, descricao: 'Número do Roteiro' },
      { id: 2, descricao: 'Data de Gravação'  },
    ])
  } 
 

  // tiposRelatorioRoupaPersonagem() {
  //   return of([
  //     { id: 1, descricao: 'Analítico' },
  //     { id: 2, descricao: 'Sintético' }
  //   ])
  // }

  // tiposRelatorioRoupaTipoPersonagem() {
  //   return of([
  //     { id: 1, descricao: 'Personagem' },
  //     { id: 2, descricao: 'Figuração' }
  //   ])
  // }
}
